const carouselItems = [
  {
    title: '2024夏季新番导览',
    subtitle: '7月番剧全收录',
    desc: '本季最受期待的夏季新番齐上线，从热血战斗到轻松日常，为你盘点不可错过的每一部精彩新作。',
    img: 'https://readdy.ai/api/search-image?query=A%20bright%20stylized%20anime%20summer%20theme%20illustration%20with%20sunny%20blue%20sky%2C%20green%20trees%2C%20and%20sparkling%20sunlight%2C%20warm%20golden%20summer%20atmosphere%2C%20clean%20composition%2C%20no%20text%2C%20no%20characters%2C%20vibrant%20and%20cheerful%20mood&width=1200&height=600&seq=carousel-summer-2024&orientation=landscape',
    alt: '2024夏季新番导览 - 最新动漫在线看',
  },
  {
    title: '热血王道番合集',
    subtitle: '燃到停不下来',
    desc: '精选最燃热血战斗动漫，从鬼灭之刃到咒术回战，每一部都让你肾上腺素飙升，感受最纯粹的热血与羁绊。',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20stylized%20anime%20action%20theme%20illustration%20with%20bursting%20energy%20waves%20in%20orange%20and%20red%20tones%2C%20dynamic%20light%20effects%2C%20explosive%20atmosphere%2C%20clean%20composition%2C%20no%20text%2C%20no%20characters%2C%20intense%20and%20powerful%20mood&width=1200&height=600&seq=carousel-action&orientation=landscape',
    alt: '热血王道番合集 - 高清动漫在线',
  },
  {
    title: '治愈系动漫推荐',
    subtitle: '温暖人心的故事',
    desc: '在快节奏的生活中偶尔也需要片刻宁静。这些治愈动漫用温柔的笔触描绘日常生活的小确幸，让你在屏幕前会心一笑。',
    img: 'https://readdy.ai/api/search-image?query=A%20soft%20stylized%20anime%20illustration%20of%20a%20cozy%20countryside%20scene%20with%20gentle%20sunlight%2C%20green%20fields%2C%20and%20fluffy%20clouds%2C%20warm%20cream%20and%20pastel%20green%20tones%2C%20peaceful%20composition%2C%20no%20text%2C%20no%20characters%2C%20calm%20and%20soothing%20mood&width=1200&height=600&seq=carousel-healing&orientation=landscape',
    alt: '治愈系动漫推荐 - 动漫全集在线看',
  },
  {
    title: '剧场版动画精选',
    subtitle: '大银幕级享受',
    desc: '新海诚、细田守等名导的剧场版动画精选合集，每一帧都是壁纸级的视觉盛宴，值得反复品味的动画电影佳作。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20stylized%20anime%20illustration%20with%20dramatic%20clouds%20and%20sunset%20sky%2C%20wide%20landscape%20composition%2C%20golden%20and%20pink%20gradient%20lighting%2C%20grand%20atmosphere%2C%20clean%20composition%2C%20no%20text%2C%20no%20characters%2C%20breathtaking%20and%20epic%20mood&width=1200&height=600&seq=carousel-movie&orientation=landscape',
    alt: '剧场版动画精选 - 番剧在线观看',
  },
  {
    title: '经典老番回顾',
    subtitle: '永不过时的神作',
    desc: '回顾那些定义了动漫历史的经典之作，从EVA到钢之炼金术师，重温那些曾经感动过我们的不朽名作。',
    img: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20stylized%20anime%20illustration%20with%20warm%20sepia%20and%20golden%20tones%2C%20vintage%20film%20texture%2C%20soft%20glow%20effects%2C%20retro%20aesthetic%2C%20clean%20composition%2C%20no%20text%2C%20no%20characters%2C%20emotional%20and%20timeless%20mood&width=1200&height=600&seq=carousel-classic&orientation=landscape',
    alt: '经典老番回顾 - 动漫网站在线看',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精心策划的动漫专题合集，帮你快速找到想看的番剧
          </p>
        </div>
        <div className="grid grid-cols-1 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="flex flex-col lg:flex-row bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200/60 transition-colors duration-300"
            >
              <div className="lg:w-[420px] lg:flex-shrink-0">
                <div className="relative w-full aspect-[2/1] lg:aspect-[4/3] lg:h-full overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.alt}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="flex-1 p-5 md:p-6 lg:p-8 flex flex-col justify-center">
                <span className="inline-block text-xs text-accent-600 font-medium mb-2 bg-accent-50 px-2.5 py-1 rounded-full w-fit">
                  {item.subtitle}
                </span>
                <h3 className="text-lg md:text-xl font-semibold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}